import SEOImageCard from "./SEOImageCard";
import { Link } from "react-router-dom";
import TopStatusTabs from "./TopStatusTabs";

const SEOLandingSection = ({
  heroImage,
  bgColor = "#E4E4E4",
  heading,
  children,
  source,
  showVideo = false,
  showActiveTab = "",
  videoSrc = "",
  videoRef = null,
  videoIndex = 0,
  ctaLink = "/get-started",
  ctaText = "Get Started",
}) => {
  const shouldRenderVideo = showVideo || Boolean(videoSrc);

  return (
    <section>
      <div className="bg-[#DADADA]">
        <div className="bg-[#DADADA] rounded-[10px] px-4 md:px-6 pt-4 md:pt-6">
          <div className="bg-white rounded-[8px] overflow-hidden border border-[#E6E6E6]">
            {showActiveTab && (
              <div className="p-4 items-center justify-center flex text-center flex-col">
                <TopStatusTabs activeItem={showActiveTab} />
              </div>
            )}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:items-stretch">
              <div className="order-1 lg:order-2 py-[20px] h-full">
                {shouldRenderVideo ? (
                  <div className="h-[350px] md:h-[560px] rounded-[10px] overflow-hidden md:mr-[27px] bg-[#17171C] mx-[5px] md:mx-0">
                    <video
                      ref={videoRef}
                      data-index={videoIndex}
                      className="w-full h-[380px] md:h-[630px] object-cover pl-[10px] md:pl-0 mt-[20px] md:mt-0"
                      muted
                      playsInline
                      preload="metadata"
                    >
                      <source src={videoSrc} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <SEOImageCard imageSrc={heroImage} bgColor={bgColor} source={source}/>
                )}
              </div>

              <div className="order-2 lg:order-1 px-6 md:px-10 py-[10px] h-full">
                <div className="flex flex-col h-full min-h-[350px] md:min-h-[560px]">
                  <h2 className="text-black whitespace-pre-line font-normal text-[32px] md:text-[36px] leading-[48px] tracking-[-1.12px] align-middle md:w-[400px]">
                    {heading}
                  </h2>

                  <div className="mt-[10px]">
                    {children}
                  </div>

                  <div className="mt-auto pt-10 flex gap-3">
                    <Link to={ctaLink}>
                      <button
                        type="button"
                        className="w-[120px] h-[48px] rounded-[8px] bg-gradient-to-r from-[#E2D8D3] via-[#D7A09B] to-[#D1C6C0] text-white text-[14px] leading-none font-normal flex items-center justify-center shadow-[0_18px_45px_rgba(0,0,0,0.10)] transition-transform duration-200 hover:scale-[1.01] active:scale-[0.99] mb-[8px]"
                      >
                        {ctaText}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SEOLandingSection;
